
import Header from "../Component/Header";
import Footer from "../Component/Footer"; 
import Breadcrumb from "../Component/Breadcrumb"; 
import LazyLoad from 'react-lazyload';
const Virtualtour = () => {
    return (
        <>
            <Header />
            <Breadcrumb pageTitle="Virtual Tour" breadcrumbName="Virtual Tour" />
            
            <div className="container body_height">
                <div className="row"> <LazyLoad><img src="https://webapi.entab.info/api/image/AFGJI/public/Images/cm.png" className="img-responsive center-block" alt="AFGJI" /> </LazyLoad></div>
            </div>
            <Footer />
        </>
    )
}

export default Virtualtour